/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentQueryAssessmentName extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentQueryAssessmentName");
    }

    getFixupPrototypeFunction() { return AssessmentQueryAssessmentName.fixupPrototype; }

    static newInstance(model: Partial<AssessmentQueryAssessmentName>): AssessmentQueryAssessmentName {
        let obj = Object.assign(new AssessmentQueryAssessmentName(), model);
        AssessmentQueryAssessmentName.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentQueryAssessmentName>): AssessmentQueryAssessmentName {
        if (!model) return null;
        return AssessmentQueryAssessmentName.newInstance(<AssessmentQueryAssessmentName> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentQueryAssessmentName) {
        if (!obj) return;

        models.AssessmentQueryAssessmentName.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentQueryAssessmentName): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentQueryAssessmentName.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Regular expression to match against Assessment name
     */
    name: string;

}
